import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, take } from 'rxjs';
import { LoadCommerceLandingUseCase } from '../../../application/commerce-registry/use-cases/load-commerce-landing.use-case';
import { ENVIRONMENT } from '../../../../environments/environment';

/**
 * For `/comercio/:slug` with no child segment: loads landing and redirects to `inicio` or
 * `formulario-registro` depending on `home_view` (`false` → form first; otherwise home first).
 * Unknown commerce (no RTDB row) redirects to `/404` when mocks are disabled.
 */
export const registryCommerceDefaultRedirectGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const load = inject(LoadCommerceLandingUseCase);
  const slug = route.parent?.paramMap.get('comercioSlug');
  if (!slug) {
    return router.parseUrl('/');
  }
  return load.execute(slug, null).pipe(
    take(1),
    map((landing) => {
      if (landing == null) {
        if (ENVIRONMENT.mockEnabled) {
          return router.createUrlTree(['/comercio', slug, 'inicio']);
        }
        return router.createUrlTree(['/404']);
      }
      const segment = landing.home_view === false ? 'formulario-registro' : 'inicio';
      return router.createUrlTree(['/comercio', slug, segment]);
    }),
    catchError(() =>
      of(
        ENVIRONMENT.mockEnabled
          ? router.createUrlTree(['/comercio', slug, 'inicio'])
          : router.createUrlTree(['/404']),
      ),
    ),
  );
};
